import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { CheckCircle2, Loader2, MailCheck, PhoneCall, Voicemail } from "lucide-react";
import { ProspectPicker } from "@/components/marketing/ProspectPicker";

const CH = {
  email: { label: "Mark as emailed", icon: MailCheck, done: "Marked as emailed" },
  call: { label: "Log call", icon: PhoneCall, done: "Call logged" },
  voicemail: { label: "Log voicemail", icon: Voicemail, done: "Voicemail logged" },
};
const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });

export const OutreachLogger = ({ channel, template, prospect, onProspect }) => {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const c = CH[channel] || CH.email;
  const Icon = c.icon;

  const log = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/prospects/${prospect.id}/outreach`, { channel, template });
      setDone(data); onProspect({ ...prospect, ...data });
      toast.success(`${c.done} — follow up ${fmt(data.followUpDue)}`);
    } catch (e) { toast.error(apiError(e.response?.data?.detail) || "Couldn't update the prospect"); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-border bg-secondary/40 p-3 space-y-2" data-testid="outreach-logger">
      <Label>Prospect (optional)</Label>
      <ProspectPicker value={prospect} onChange={(p) => { setDone(null); onProspect(p); }} />
      {prospect && (done ? (
        <p className="text-sm text-emerald-400 flex items-center gap-1.5" data-testid="outreach-logged">
          <CheckCircle2 className="w-4 h-4" />{c.done}. Status is now “{done.status}” — follow up on {fmt(done.followUpDue)}.
        </p>
      ) : (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 justify-between">
          <span className="text-xs text-muted-foreground">After you send it, record it so the follow-up date is set for you.</span>
          <Button onClick={log} disabled={busy} variant="outline" data-testid="outreach-log-btn">{busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Icon className="w-4 h-4 mr-2" />}{c.label}</Button>
        </div>
      ))}
    </div>
  );
};
